<template>

    <div class="m-auto px-8 md:px-20 pb-8">
        <h1 class="py-5 text-2xl font-bold">Fasce di ricavo per {{ business_unit?.nome }}</h1>

        <Alert class="bg-next-bri" v-if="success_message">{{ success_message }}</Alert>
        <Alert class="bg-next-orange" v-if="!can_edit">{{ message }}</Alert>

        <div class="my-3 col-span-3" v-else>
            <div class="grid grid-cols-[repeat(3,_minmax(0,_1fr))_max-content] gap-4 mb-3">
                <p class="font-bold">Etichetta</p>
                <p class="font-bold">Valore minimo</p>
                <p class="font-bold">Valore massimo</p>
                <p class="font-bold"></p>
                <template v-for="(fascia, i) in fasce" :key="i">
                    <div class="flex flex-col">
                        <Field :label-visible="false" placeholder="Descrizione"
                               :errors="getErrorsFasce(i, 'descrizione')"
                               v-model="fascia.descrizione">
                        </Field>
                    </div>
                    <div class="flex flex-col">
                        <Field :label-visible="false" placeholder="Minimo"
                               :errors="getErrorsFasce(i, 'min')"
                               :inputAttrs="{min:0,step:'0.01'}"
                               v-model="fascia.min" type="number">
                        </Field>
                    </div>
                    <div class="flex flex-col">
                        <Field :label-visible="false" placeholder="Massimo"
                               :errors="getErrorsFasce(i, 'max')"
                               :inputAttrs="{min:0,step:'0.01'}"
                               v-model="fascia.max" type="number">
                        </Field>
                    </div>
                    <div class="flex items-center">
                        <NextButton variant="outline-secondary" @click="removeFasce(i)"
                                    class="col flex justify-center items-center h-8 w-8"><i class="icon-x"></i>
                        </NextButton>
                    </div>
                </template>
                <div class="flex justify-end col-span-4">
                    <NextButton variant="primary" @click="addFascia"
                                class="col flex justify-center items-center h-8 w-8"><i
                        class="icon-croce_quadrata"></i>
                    </NextButton>
                </div>
            </div>

            <div class="flex pt-3 justify-end">
                <NextButton class="px-3 py-2" @click="save">Salva</NextButton>
            </div>
        </div>

    </div>
</template>

<script lang="ts">
import {Options, Vue} from 'vue-class-component';
import Loading from "@/components/Loading.vue";
import NextButton from "@/components/NextButton.vue";
import Field from "@/components/Field.vue";
import businessUnitsManager from "@/api/BusinessUnits";
import Alert from "@/components/Alert.vue";

@Options({
    name: 'FasceDiRicavo',
    components: {
        Alert,
        Field,
        NextButton,
        Loading
    },
    props: {
        id: {
            type: [String, Number],
            required: true
        }
    }
})
export default class FasceDiRicavo extends Vue {
    id!: string | number
    fasce: any[] = []
    errors = {}
    can_edit = true
    success_message = ''
    business_unit = {}
    message = ''

    created() {
        businessUnitsManager.businessUnit(this.id).then((res: any) => {
            this.business_unit = res.data

            this.fetchFasce().catch(() => {
                this.can_edit = false
                this.message = 'Non hai i permessi per modificare le fasce di ricavo'
            })

        }).catch(() => {
            this.can_edit = false
            this.message = 'Business unit non trovata'
        })
    }

    fetchFasce() {
        return businessUnitsManager.fasceRicavo(this.id).then((response) => {
            this.fasce = response.data
        })
    }

    removeFasce(idx: number) {
        this.fasce.splice(idx, 1)
    }

    getErrorsFasce(index: string | number, field: string) {
        return (this.errors as any)[`fasce.${index}.${field}`]
    }

    addFascia() {
        this.fasce.push({descrizione: null, min: 0, max: 0})
    }

    save() {
        this.success_message = ''
        businessUnitsManager.saveFasceRicavo(this.id, this.fasce).then(() => {
            this.errors = {}
            this.success_message = 'Fasce di ricavo salvate con successo'
        }).catch((error) => {
            this.errors = error.response.data.errors
            this.success_message = ''
        })
    }
}

</script>
